import { useQuery } from "@1f/react-sdk"
import sharedDatasInstance from "../sharedDatas"
import { getDossiersByAzienda } from "../query/dossierQueries";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";

export const DossierApi = () => {
    const aziendaId = sharedDatasInstance.getPropertyByName("aziendaId");
    const tenantId = sharedDatasInstance.getPropertyByName("tenantId");
    const loggedUserId = sharedDatasInstance.getPropertyByName("userId");
    const errorApiHelpers = apiErrorHelper();
    const queryGetDossiersByAzienda = useQuery(
        getDossiersByAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )

    const getDossiers = async () => {
        try {
            let dossierRespnse = await queryGetDossiersByAzienda.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                userId: loggedUserId
            });
            if(dossierRespnse.data.data.getDossiers) {
                return dossierRespnse.data.data.getDossiers;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || `Errore durante il recupero delle anagrafiche`);
        }
    }

    return{
        getDossiers
    }
}